export enum MainPage {
  Swap = 'swap',
  Terms = 'terms',
  Index = 'index',
  Referral = 'ref',
  Points = 'points',
  Guilds = 'guilds',
  Vaults = 'vaults',
  Markets = 'markets',
  Portfolio = 'portfolio',
  LpRewards = 'lp-rewards',
  Maintenance = 'maintenance',
  TradingBots = 'trading-bots',
  FeeDiscounts = 'fee-discounts',
  TradeAndEarn = 'trade-and-earn',
  Institutional = 'institutional',
  PrivacyPolicy = 'privacy-policy',
  PointsS1Ended = 'points-s1-ended',
  TradingBotsLiquidityBots = 'trading-bots-liquidity-bots',
  TradingBotsLiquidityBotsSpot = 'trading-bots-liquidity-bots-spot',
  TradingBotsLiquidityBotsSpotHistory = 'trading-bots-liquidity-bots-spot-history',
  TeslaCompetitionTerms = 'tesla-competition-terms',
  LikeAGCompetitionTerms = 'like-a-g-competition-terms',
  OwnYourAssetCompetitionTerms = 'own-your-assets-competition-terms',
  VolumeVictoryCompetitionTerms = 'volume-victory-competition-terms',
  CompetitionPrivacyPolicyTesla = 'competition-privacy-policy-tesla',
  CompetitionPrivacyPolicyGwagon = 'competition-privacy-policy-gwagon',
  CompetitionPrivacyPolicyOwnYourAsset = 'competition-privacy-policy-own-your-assets'
}

export enum CampaignSubPage {
  GuildDetails = 'guild-guild'
}

export enum TradingBotsSubPage {
  LiquiditySpotMarket = 'trading-bots-liquidity-bots-spot'
}

export enum TradePage {
  Spot = 'spot',
  Futures = 'futures'
}

export enum TradeSubPage {
  Stocks = 'stocks',
  Spot = 'spot-slug',
  Market = 'market-market',
  Futures = 'futures-slug',
  Derivatives = 'derivatives-derivative'
}

export enum TradeSubPagePath {
  Stocks = '/futures/stocks'
}

export enum LiquidityRewardsPage {
  Home = 'lp-rewards',
  Dashboard = 'lp-rewards-dashboard',
  CampaignDetails = 'lp-rewards-campaign'
}

export enum PortfolioSubPage {
  Settings = 'portfolio-settings',
  Balances = 'portfolio-balances',
  Positions = 'portfolio-positions',
  OrdersSpot = 'portfolio-orders-spot',
  HistorySwap = 'portfolio-history-swap',
  Subaccounts = 'portfolio-subaccounts',
  OrdersFutures = 'portfolio-orders-futures',
  HistoryWallet = 'portfolio-history-wallet',
  SettingsAuthz = 'portfolio-settings-authz',
  OrdersSpotGrid = 'portfolio-orders-spot-grid',
  OrdersFuturesGrid = 'portfolio-orders-futures-grid',
  SettingsAuthzGranter = 'portfolio-settings-authz-granter',
  HistoryFundingHistory = 'portfolio-history-funding-history',
  OrdersSpotTradeHistory = 'portfolio-orders-spot-trade-history',
  OrdersFuturesTradeHistory = 'portfolio-orders-futures-trade-history',
  OrdersFuturesOrderHistory = 'portfolio-orders-futures-order-history',
  OrdersFuturesAdvancedOrders = 'portfolio-orders-futures-advanced-orders'
}

export enum LeaderboardSubPage {
  Pnl = 'leaderboard',
  Competition = 'leaderboard-competition',
  PastCompetitions = 'leaderboard-past-competitions'
}
